// src/components/Toast.jsx
import { useEffect, useState } from "react";

export default function Toast({ msg, ok = true, onDone }) {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => { setVisible(false); onDone?.(); }, 3000);
    return () => clearTimeout(t);
  }, [onDone]);
  if (!visible) return null;
  return (
    <div style={{
      position:"fixed", bottom:28, left:"50%", transform:"translateX(-50%)",
      background: ok ? "var(--ink)" : "var(--burg)",
      color:"var(--cream)", padding:"12px 28px",
      fontSize:11, letterSpacing:3, textTransform:"uppercase",
      zIndex:999, boxShadow:"0 8px 32px rgba(0,0,0,0.18)",
      animation:"fadeUp .3s ease", whiteSpace:"nowrap",
    }}>
      {msg}
    </div>
  );
}
